import { createAsyncThunk } from '@reduxjs/toolkit'

import { ITypeTicketData } from 'meta/pages/v4/typeticket'
import { TypeTicketController } from 'controller/typeticket'

type Returned = ITypeTicketData

type Props = {
  id: number
}

export const getData = createAsyncThunk<Returned, Props>('pages/typeticket/data', async (props) => {
  const { id } = props

  return TypeTicketController.getData({ id })
})
